import Toast from '@/components/common/toasts'
import { validateTargetName as validateTargetNameAPI } from '@/api'

const getAllAttributesFromQuery = function (query) {
  const attributes = []
  for (const i in query) {
    const current = query[i]
    if (Array.isArray(current)) {
      attributes.push.apply(attributes, getAllAttributesFromQuery(current))
    } else if (typeof current === 'object') {
      attributes.push(current)
    }
    // else it is an OR or an AND
  }
  return attributes
}

const hasRemovedAttributes = function (query) {
  const attributes = getAllAttributesFromQuery(query)
  for (const at of attributes) {
    if (at['removed']) {  // only looking for a true value here...
      return true
    }
  }
  return false
}

const validateTargetName = async function (targetName, type) {
  // eslint-disable-next-line
  const validRegex = new RegExp(/^[^~`'”^,@={}\\|\[\];"?!:#%]+$/)
  if (validRegex.test(targetName)) {
    return validateTargetNameAPI({display_name: targetName, targetType: type})
    .then(res => {
      if (res.data.passNameLookup === true && res.data.passedPruning === true) {
        return true
      } else if (res.data.passNameLookup === false) {
        Toast.error({
          title: 'Target Name Error',
          message: 'Duplicate Target Name: Please re-enter a unique target name and try again.',
          timeout: 15000
        })
        return false
      } else if (res.data.passedPruning === false) {
        Toast.error({
          title: 'Target Name Error',
          message: 'You have invalid characters in your name "' + targetName + '". Please remove them and try again.',
          timeout: 15000
        })
        return false
      }
    })
  } else {
    Toast.error({
      title: 'Target Name Error',
      message: 'You have invalid characters in your name "' + targetName + '". Please remove them and try again.',
      timeout: 15000
    })
    return false
  }
}

export {
  hasRemovedAttributes,
  validateTargetName
}



// WEBPACK FOOTER //
// ./src/app/appLogic/targets/TargetLogic.js